import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Typography, Box, Paper, CircularProgress, Alert } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import "../directory/Directory.css";

const Directory = () => {
  const [contractors, setContractors] = useState([]);
  const [expandedId, setExpandedId] = useState(null);
  const [contractorUsers, setContractorUsers] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [allUsers, setAllUsers] = useState([]);
  const [allRelationships, setAllRelationships] = useState([]);
  const [debug, setDebug] = useState('');

  useEffect(() => {
    fetchAllData();
  }, []);

  const fetchAllData = async () => {
    setLoading(true);
    try {
      
      const contractorsResponse = await axios.get('https://test2.planfix-to-syrve.com/contractors');
      console.log('Отримані компанії:', contractorsResponse.data);
      setContractors(contractorsResponse.data);
      
      
      const usersResponse = await axios.get('https://test2.planfix-to-syrve.com/users');
      console.log('Отримані користувачі:', usersResponse.data);
      setAllUsers(usersResponse.data);
      
      
      try {
        const relationshipsResponse = await axios.get('https://test2.planfix-to-syrve.com/all-user-contractors');
        console.log('Отримані зв\'язки:', relationshipsResponse.data);
        setAllRelationships(relationshipsResponse.data);
      } catch (err) {
        console.log('Ендпоінт all-user-contractors не доступний, використовуємо покомпанійне завантаження');
      }
      
      setError('');
    } catch (error) {
      console.error('Помилка отримання даних:', error);
      setError('Помилка при завантаженні даних');
    } finally {
      setLoading(false);
    }
  };

  const fetchContractorUsers = async (contractorId) => {
    try {
      console.log('========== ПОЧАТОК ЗАВАНТАЖЕННЯ ==========');
      console.log('Завантаження користувачів для компанії ID:', contractorId);
      
      
      console.log('Спроба 1: Отримуємо зв\'язки через contractor-users ендпоінт...');
      let relatedUserIds = [];
      
      try {
        const relationshipsResponse = await axios.get(`https://test2.planfix-to-syrve.com/contractor-users/${contractorId}`);
        console.log('Відповідь від contractor-users:', relationshipsResponse.data);
        
        if (Array.isArray(relationshipsResponse.data)) {
          relatedUserIds = relationshipsResponse.data.map(item => {
            
            if (item.user_id) return item.user_id;
            if (item.userId) return item.userId;
            if (item.id) return item.id;
            return item;
          });
        } else if (relationshipsResponse.data && typeof relationshipsResponse.data === 'object') {
          if (relationshipsResponse.data.user_id) {
            relatedUserIds = [relationshipsResponse.data.user_id];
          }
        }
      } catch (error) {
        console.log('Помилка отримання через contractor-users:', error.message);
      }
      
      
      if (relatedUserIds.length === 0) {
        console.log('Спроба 2: Шукаємо через перевірку всіх користувачів...');
        
        
        for (const user of allUsers) {
          try {
            const checkResponse = await axios.get(`https://test2.planfix-to-syrve.com/check-user-contractor/${user.id}`);
            console.log(`Користувач ${user.username} (ID: ${user.id}):`, checkResponse.data);
            
            
            if (checkResponse.data.hasContractor && checkResponse.data.contractorId === contractorId) {
              relatedUserIds.push(user.id);
            }
          } catch (err) {
            console.log(`Помилка перевірки користувача ${user.id}:`, err.message);
          }
        }
      }
      
      console.log('Знайдені user_id:', relatedUserIds);
      
      
      const usersForContractor = allUsers.filter(user => relatedUserIds.includes(user.id));
      
      console.log('Знайдені користувачі для компанії:', usersForContractor);
      console.log('========== КІНЕЦЬ ЗАВАНТАЖЕННЯ ==========\n');
      
      setContractorUsers(prev => ({
        ...prev,
        [contractorId]: usersForContractor
      }));
      
    
      
    } catch (error) {
      console.error('Помилка отримання користувачів для компанії:', error);
      setContractorUsers(prev => ({
        ...prev,
        [contractorId]: []
      }));
      setDebug(`Помилка: ${error.message}`);
    }
  };

  const handleContractorClick = async (contractor) => {
    if (expandedId === contractor.id) {
      setExpandedId(null);
    } else {
      setExpandedId(contractor.id);
      
      
      if (!contractorUsers[contractor.id]) {
        await fetchContractorUsers(contractor.id);
      } else {
      
      }
    }
  };

  const filteredContractors = contractors.filter(contractor =>
    contractor.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Box sx={{ 
     
      fontFamily: 'Arial, sans-serif', 
      maxWidth: '800px', 
      margin: '0 auto',
      padding: '20px'
    }}>
      <Typography 
        variant="h4" 
        
        sx={{ 
          color: '#333', 
          marginTop: "60px",
          borderBottom: '2px solid #333', 
          paddingBottom: '10px',
          marginBottom: '20px',
          textAlign: 'center',
          
        }}
      >
        Довідник компаній
      </Typography>
      
      <Box sx={{ textAlign: 'center', marginBottom: '20px' }}>
        <input
          type="text"
          placeholder="Пошук компанії..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            padding: '10px',
            width: '300px',
            borderRadius: '5px',
            border: '1px solid #ddd',
            fontSize: '16px'
          }}
        />
      </Box>

      {}
      {debug && (
        <Alert severity="info" sx={{ marginBottom: '20px' }}>
          {debug}
        </Alert>
      )}

      {error && (
        <Alert severity="error" sx={{ marginBottom: '20px' }}>
          {error}
        </Alert>
      )}

      {loading && contractors.length === 0 ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', padding: '40px' }}>
          <CircularProgress />
        </Box>
      ) : (
        <Box>
          {filteredContractors.length === 0 ? (
            <Paper sx={{ padding: '20px', textAlign: 'center', color: '#666' }}>
              {searchTerm ? 'Компанії не знайдено' : 'Список компаній порожній'}
            </Paper>
          ) : (
            filteredContractors.map((contractor) => {
              
              const userCount = contractorUsers[contractor.id]?.length || 0;
              
              return (
                <Paper 
                  key={contractor.id} 
                  sx={{ 
                    marginBottom: '10px',
                    overflow: 'hidden'
                  }}
                >
                  {}
                  <Box 
                    onClick={() => handleContractorClick(contractor)}
                    sx={{
                      padding: '15px 20px',
                      backgroundColor: '#f5f5f5',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      '&:hover': {
                        backgroundColor: '#e8e8e8'
                      }
                    }}
                  >
                    <Box>
                      <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        {contractor.name}
                      </Typography>
                      {userCount > 0 && (
                        <Typography variant="caption" sx={{ color: '#4CAF50' }}>
                          {userCount} {userCount === 1 ? 'користувач' : 'користувачів'}
                        </Typography>
                      )}
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <Typography variant="body2" sx={{ color: '#666' }}>
                        ID: {contractor.id}
                      </Typography>
                      {expandedId === contractor.id ? (
                        <ExpandLessIcon sx={{ color: '#666' }} />
                      ) : (
                        <ExpandMoreIcon sx={{ color: '#666' }} />
                      )}
                    </Box>
                  </Box>

                  {}
                  {expandedId === contractor.id && (
                    <Box sx={{ padding: '20px', backgroundColor: '#fafafa' }}>
                      <Typography variant="h6" sx={{ marginBottom: '15px', color: '#333' }}>
                        Користувачі компанії:
                      </Typography>
                      
                      {contractorUsers[contractor.id] ? (
                        contractorUsers[contractor.id].length > 0 ? (
                          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            {contractorUsers[contractor.id].map((user) => (
                              <Paper 
                                key={user.id} 
                                variant="outlined"
                                sx={{ 
                                  padding: '15px',
                                  backgroundColor: 'white',
                                  borderLeft: '4px solid #4CAF50'
                                }}
                              >
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                  <Box>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                                      {user.username || 'Без імені'}
                                    </Typography>
                                    {user.email && (
                                      <Typography variant="body2" sx={{ color: '#666', marginTop: '4px' }}>
                                        Email: {user.email}
                                      </Typography>
                                    )}
                                  </Box>
                                  <Typography variant="caption" sx={{ color: '#999' }}>
                                    ID: {user.id}
                                  </Typography>
                                </Box>
                                {user.user_rule && (
                                  <Typography variant="body2" sx={{ marginTop: '8px', color: '#4CAF50' }}>
                                    Роль: {user.user_rule}
                                  </Typography>
                                )}
                              </Paper>
                            ))}
                          </Box>
                        ) : (
                          <Box>
                            <Typography sx={{ color: '#666', textAlign: 'center', padding: '20px' }}>
                              Немає користувачів, прив'язаних до цієї компанії
                            </Typography>
                            <Typography variant="caption" sx={{ color: '#999', textAlign: 'center', display: 'block' }}>
                              (ID компанії: {contractor.id})
                            </Typography>
                          </Box>
                        )
                      ) : (
                        <Box sx={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                          <CircularProgress size={30} />
                        </Box>
                      )}
                    </Box>
                  )}
                </Paper>
              );
            })
          )}
        </Box>
      )}
    </Box>
  );
};

export default Directory;
